<script>
import CustomersApi from "@/services/customers-api";
import Swal from "sweetalert2";
import Vue from 'vue'

export default {
    props: {
      firstDay:{
          type:String,
          default:null
      },
      lastDay:{
          type:String,
          default:null
      }
    },
    data(){
        return{
            fields: [
                { key:"checkbox"},
                { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold  align-middle my-auto",},
                { key:"extId", label: "Code",   sortable: false, tdClass:"font-weight-bold align-middle my-auto",},

                { key:"category", label: "Type",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none align-middle my-auto" },

                { key:"country", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none align-middle my-auto" },
                { key:"city", label: "",   thClass:"text-left d-md-table-cell d-none", tdClass:"text-left d-md-table-cell d-none align-middle my-auto"},
                // { key:"phone", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"address", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none align-middle my-auto" },
                { key:"users", label: "",thClass:"text-center", tdClass:"text-center align-middle my-auto"},
                { key:"status", label: "",thClass:"text-center", tdClass:"text-center align-middle my-auto"},
                

                { key:"actions", label:"", tdClass:"text-right align-middle my-auto"}],
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
            customersList:[],
            isLoadingInProgress: false,
            isSendingMailInProgress: false,
            
            AllInactiveCustomersIds: null,
            isSendingMailToSelected: false,
            selected: new Set([]),
           
            selectAll: 0,
           
        }
    },
    methods:{

        isChecked(item){
            return this.selected.has(item.id) ? 1 : 0
        },

        handleCheckboxChange(item) {
            if (this.selected && this.selected.has(item.id)) {
                this.selected.delete(item.id);
            } else {
                this.selected.add(item.id);
            }
        },

        sendMailToSelected() {
            if (this.selected.size === 0) {
              return;
            }
        
            Swal.fire({
              title: "Rappeler par mail",
              html: "Envoyer un e-mail de rappel aux clients sélectionnés (<strong>" + this.selected.size + " clients</strong>) ?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Oui, envoyer",
              cancelButtonText: "Annuler",
            }).then((result) => {
              if (result.value) {
                this.isSendingMailToSelected = true;
                var customerIds = Array.from(this.selected);
                return CustomersApi.remindInactiveCustomers(customerIds).then((result) => {
                  if (result && !result.length) {
                    Vue.prototype.$snotify.success("Mail envoyé aux clients sélectionnés");
                  } else {
                    Vue.prototype.$snotify.error("L'envoi du mail a échoué pour certain clients :"+ result);
                  }
                }).finally(() => {
                  this.isSendingMailToSelected = false;
                });
              }
            });
          },

        getAllInactiveCustomersIds(){
            CustomersApi.getAllInactiveCustomersIds().then(
                result => {
                    this.AllInactiveCustomersIds= result;
                    if(this.AllInactiveCustomersIds != null){
                        this.selected =new Set (this.AllInactiveCustomersIds);
                    }
            });
        },
        getInactiveCustomers(){
            this.isLoadingInProgress=true;
            CustomersApi.getInactiveCustomers(this.pagemodel.currentPage, this.pagemodel.perPage).then(
                result => {

                this.customersList=result.list;
                this.pagemodel.totalRows = result.total;
                this.pagemodel.currentPage = result.page;
                this.pagemodel.perPage = result.pageSize;
                this.pagemodel.pageSize = result.pageSize;

            }
            ).finally(()=>{
                this.isLoadingInProgress=false;
            })
        },

        sendRemindMail(customer) {

            if (!customer) {
                return;
            }


            Swal.fire({
                title: "Rappeler par mail",
                text: "Envoyer un e-mail de rappel au client " + customer.name + " ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Oui, envoyer",
                cancelButtonText: "Annuler"
            })    

            .then(result => {
                if (result.value) {

                    this.isSendingMailInProgress=true;
                    return CustomersApi.remindInactiveCustomer(customer ? customer.id : null).then(
                        (result) => {

                        if (result) {
                            Vue.prototype.$snotify.success("Mail envoyé au client " + customer.name);
                        } else {
                            Vue.prototype.$snotify.error("L'envoi du mail a échoué");
                        }
                    }
                    ).finally(()=>{
                        this.isSendingMailInProgress=false;
                    })

         
                }
            });            


            
        },
    },
    mounted(){ 
        this.getInactiveCustomers()
    },

    computed: {

    },

    watch: {

        selectAll: function(){
            if (this.selectAll == "1") {
                this.getAllInactiveCustomersIds();             
            } else {
                this.selected = new Set([]);
            }
        },
    }
}
</script>
<template>
    <div class="clearfix m-4">
        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark">Clients non actifs </h4>
       
        <div class="row mr-3">

            <div class="col-12 text-right">
                <b-button
                variant="outline-dark"
                size="sm"
                class="float-right  mt-2"
                @click="sendMailToSelected"
                :disabled="isSendingMailToSelected"
                >
                    <b-spinner small :class="isSendingMailToSelected ? 'mr-2' : 'd-none'"></b-spinner>
                    <span class="font-size-12">
                        <i v-if="!isSendingMailToSelected" class="fas fa-bell font-size-14 align-middle mr-2"></i>
                        Rappeler les clients sélectionnés
                    </span>
                </b-button>
            </div>

        </div>
        


        <div class="table-responsive pt-4 mb-0" >
            <b-table
                selectMode="single"
                :busy="isLoadingInProgress"
                :striped="true"
                :small="false"
                :hover="true"
                :items="customersList"
                :fields="fields"
                
                :perPage="pagemodel.perPage"
                class="table  "

            >
            <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>
                <template v-slot:head(checkbox)>
                    <div class="form-group  text-center m-0" >
                        <b-form-checkbox
                        value="1"
                        unchecked-value="0"
                        v-model="selectAll"
                        class="custom-checkbox custom-checkbox-success mb-0 mt-0"
                        ></b-form-checkbox>
                    </div>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                    <div class="float  text-center m-0">
                        <div class="form-group d-flex align-items-center justify-content-center">
                            <b-form-checkbox  
                            :id="'checkbox_' + item.id"
                            value="1"
                            unchecked-value="0"
                            class="custom-checkbox custom-checkbox-success mb-0 mt-0"    
                            :checked="isChecked(item)"
                            @change="handleCheckboxChange(item)"
                            ></b-form-checkbox> 
                        </div>
                    </div>
                </template>
                <template v-slot:head(companyName)>
                    {{ $t("subscription.table.name") }} 
                </template>
                <template v-slot:head(country)>
                    {{ $t("subscription.table.country") }} 
                </template>
                <template v-slot:head(city)>
                    {{ $t("subscription.table.city") }} 
                </template>
                <template v-slot:head(extId)>
                    {{ $t("subscription.table.code") }} 
                </template>
                <template v-slot:head(phone)>
                    {{ $t("subscription.table.phone") }} 
                </template>

                <template v-slot:head(status)>
                   Actif 
                </template>
                <template v-slot:head(users)>
                    {{ $t("subscription.table.users") }} 
                </template>
                 <template v-slot:head(trader)>
                    {{ $t("subscription.table.trader") }} 
                </template>
                <template v-slot:cell(status)="{value}">
                    <i :class="value===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
                </template>
                <template v-slot:cell(country)="{value}">
                    {{value.name}}
                </template>
                
                <template v-slot:cell(city)="{value}">
                    {{value.name}}
                </template>

                <template v-slot:cell(category)="{value}">
                    {{value ===0 ? 'Officine' : value === 1 ? "Para" : "Clinique"}}
                </template>

                <template v-slot:cell(users)="{item}">
                    <a :href="'/customer-utilisateurs?id=' + item.id">
                        {{ item.usersCount }} utilisateur(s)
                        </a>
                
              </template>
                <template v-slot:cell(actions)="{item}">
                    <b-button variant="outline-dark" size="sm" @click="sendRemindMail(item);" class="mr-2 ml-2" >
                        <b-spinner small :class="isSendingMailInProgress ? 'mr-2' : 'd-none'"></b-spinner>
                        <span class="font-size-12"><i v-if="!isSendingMailInProgress" class="fas fa-bell font-size-14 align-middle mr-2 " ></i> Rappeler par Mail</span>
                    </b-button>
                </template>
              





           









            

            </b-table>
            <span v-if="!isLoadingInProgress && !customersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getInactiveCustomers()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getInactiveCustomers()" :disabled="isLoadingInProgress" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  --> 
    </div>
</template>